import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './css/index.css';
import errorReport from './utils/errorReport';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

window.addEventListener('error',({error})=>{
  errorReport(error);
  return false;
});


// WEBPACK FOOTER //
// ./src/index.js